import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import reportWebVitals from "reportWebVitals";

import { WizardFactory } from "@platformComponents/WizardMobile/WizardFactory";
import { UnconnectedErrorBoundary as ErrorBoundary } from "shared/components/ErrorBoundary";

import { registerServiceWorker } from "shared/helpers/serviceWorkerRegistration";

import "i18n";
import "insideEvent";

import "@sharedAssets/global.scss";
import "@brandAssets/scss/wizard.scss";

import store from "@storeEnv/wizzardStore";

registerServiceWorker();

ReactDOM.createRoot(document.getElementById("wizard")).render(
  <ErrorBoundary>
    <Provider store={store}>
      <WizardFactory />
    </Provider>
  </ErrorBoundary>
);

reportWebVitals(console.log);
